module.exports = __webpack_public_path__ + "media/close.017f7c82.svg";